import type { ActivityCode } from './activities';
import type { Level } from '../enums';

/** Текстовые якоря уровней 1–5 для самооценки при онбординге (BLUEPRINT 2.2.4). */
export type LevelAnchors = Readonly<Record<Level, string>>;

const generic: LevelAnchors = {
  1: 'Не пробовал или пробовал один раз',
  2: 'Играл пару раз, правила знаю',
  3: 'Играю регулярно, держу темп',
  4: 'Уверенный игрок, могу подтянуть других',
  5: 'Играю на турнирах',
};

export const LEVEL_ANCHORS: Readonly<Partial<Record<ActivityCode, LevelAnchors>>> & {
  generic: LevelAnchors;
} = {
  generic,
  padel: {
    1: 'Держал ракетку пару раз, правила в общих чертах',
    2: 'Играл несколько раз, попадаю по мячу, розыгрыш короткий',
    3: 'Играю регулярно, уверенно держу розыгрыш, знаю стекло',
    4: 'Играю тактически: лоб, бандеха, выход к сетке',
    5: 'Турнирный уровень, играю на результат',
  },
  volleyball: {
    1: 'Играл во дворе или на пляже',
    2: 'Приём и подача есть, позиции знаю',
    3: 'Играю регулярно, держу приём, атакую',
    4: 'Уверенно на любой позиции, читаю игру',
    5: 'Секция или любительская лига',
  },
  football5: {
    1: 'Играл редко, для настроения',
    2: 'Играю иногда, держу мяч под контролем',
    3: 'Играю регулярно, понимаю позицию и пас',
    4: 'Уверенный игрок, веду игру',
    5: 'Любительская лига или бывшая секция',
  },
  tabletennis: {
    1: 'Играл в школе или на даче',
    2: 'Держу розыгрыш, подача без вращения',
    3: 'Играю регулярно, есть подача с вращением и топспин',
    4: 'Уверенно атакую и защищаюсь, играю на счёт',
    5: 'Разряд или клубные турниры',
  },
};

export function levelAnchorsFor(code: string): LevelAnchors {
  return LEVEL_ANCHORS[code as ActivityCode] ?? LEVEL_ANCHORS.generic;
}
